import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { BackToPageDesktop, BackToPageMobile } from '../../components/BackToPage';
import { TBackBtnTexts } from './utils/getButtonTextByReferrer';
import { useFormTracking } from '../../utils/useFormTracking';
import { IBackToPageContainerContextProps } from './types';
import { useButtonProps } from './utils/useButtonProps';
import { selectIsWebview } from '../../selectors/selectIsWebview';
import { withApplicationContext } from '../../utils/applicationContext';
import { IApplicationContext } from '../../types/ICustomContextParams';

export function _BackToPageContainer(props: IBackToPageContainerContextProps) {
  const isDesktop = useIsDesktop();
  const { trackBackToPage } = useFormTracking();
  const { href, text } = useButtonProps(props);
  const isWebview = useSelector(selectIsWebview);

  /**
   * Для вебвью никогда не показывает кнопку назад/крестик закрытия
   */
  if (!href || !text || isWebview) {
    return null;
  }

  const BackToPage = isDesktop ? BackToPageDesktop : BackToPageMobile;

  return <BackToPage text={text} href={href} onClick={trackBackToPage} />;
}

const mapContextToProps = ({ config }: IApplicationContext): IBackToPageContainerContextProps => {
  return { backBtnTexts: config.get<TBackBtnTexts>('requestFormRealtor.backBtnTexts') || [] };
};

export const BackToPageContainer = withApplicationContext(mapContextToProps)(_BackToPageContainer);
